import React from "react"
import Icon from "../Utils/Icon"

interface MenuContent {
  key: string
  icon: any
  title: string
  suffixIcon?: any
}
interface MenuType extends Object {
  lamp: MenuContent
  shelterLamp: MenuContent
  widget: MenuContent
  place: MenuContent
  account: MenuContent
  terms: MenuContent
  help: MenuContent
}

const Menu: MenuType = {
  lamp: {
    key: "lamp",
    icon: (className) => (
      <Icon className={className} type="original" name="lamp" />
    ),
    title: "混雑ランプ",
  },
  shelterLamp: {
    key: "shelterLamp",
    icon: (className) => (
      <Icon className={className} type="original" name="lamp" />
    ),
    title: "混雑ランプ",
  },
  widget: {
    key: "widget",
    icon: (className) => (
      <Icon className={className} type="feather" name="globe" />
    ),
    title: "ホームページ連携",
  },
  place: {
    key: "place",
    icon: (className) => (
      <Icon className={className} type="feather" name="file-text" />
    ),
    title: "基本情報",
  },
  account: {
    key: "account",
    icon: (className) => (
      <Icon className={className} type="feather" name="settings" />
    ),
    title: "アカウント設定",
    suffixIcon: (className) => (
      <Icon
        className={className}
        type="feather"
        name="external-link"
        attr={{ width: 15, height: 15 }}
      />
    ),
  },
  terms: {
    key: "terms",
    icon: (className) => (
      <Icon className={className} type="feather" name="info" />
    ),
    title: "利用規約",
  },
  help: {
    key: "help",
    icon: (className) => (
      <Icon className={className} type="feather" name="help-circle" />
    ),
    title: "ヘルプ",
  },
}

export const AvailableMenu = (availableMenus: string[]) =>
  Object.values(Menu).filter((m) => availableMenus.includes(m.key))

export default Menu
